import {IEntryForShow} from '../_interface/ientry-for-show';
import dayjs from 'dayjs';
import {ICalendarOverlay} from '../_interface/ICalendarOverlay';

export const calendarOverlayFromEntries = (entries: IEntryForShow[]): ICalendarOverlay[] =>
	entries.reduce((acc: ICalendarOverlay[], entry, i) => {
		const present = acc.find(item => dayjs(item.date).isSame(dayjs(entry.entryDateTime), 'day'));
		if (i === 0 || !present) {
			const date = dayjs(entry.entryDateTime);
			return [...acc, {
				date: date.startOf('date').toISOString(),
				dateObj: {
					day : date.date(),
					month : date.month() + 1,
					year : date.year()
				},
				entries: [entry]
			}];
		} else present.entries.push(entry);
		return acc;
	}, []);
